import React, { useEffect, useState, useRef } from "react";
import salesDood2 from "../../utils/salesDood2.png";
import {
  AiOutlineSetting,
  AiOutlineSearch,
  AiOutlineBell,
  AiOutlineClose,
  AiOutlineUser,
} from "react-icons/ai";
import { RiFullscreenLine } from "react-icons/ri";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useLocation, useNavigate } from "react-router-dom";
import "../../css/Header.css";
import { CURRENT_USER_NAME } from "../../utils/constants";
import {
  ChevronDown,
  LogOut,
  MessageSquare,
  Power,
  Settings,
  X,
} from "lucide-react";
import { getAllMenuModulePathAndLogo } from "../../utils/MenuModulePathAndLogoListOfThisProduct";
import useApi from "../../utils/useApi";
// import AiTutor from "../aiTutor/AiTutor";
// import AiTutorModal from "../aiTutor/AiTutor";
import canUserSeeThis from "../common/CheckCanUserSeeThis";

const Header = ({ setCurrentSelectedMouleObject }) => {
  const [hideRightSideBar, sethideRightSideBar] = useState(true);
  const navigate = useNavigate();
  const [searchItem, setSearchItem] = useState("");
  const [team, setTeam] = useState("");
  const [dept, setDept] = useState("");
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const profileMenuRef = useRef(null);
  // Close profile dropdown when clicking outside
  useEffect(() => {
    if (!profileMenuOpen) return;
    function handleClickOutside(event) {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target)
      ) {
        setProfileMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profileMenuOpen]);

  const rightSidebarRef = useRef(null);
  const toggleButtonRef = useRef(null);
  const searchDropdownRef = useRef(null);

  const menu_list = getAllMenuModulePathAndLogo();
  const [filteredMenus, setFilteredMenus] = useState([]);
  const [focusedIndex, setFocusedIndex] = useState(-1);

  const COMPANY_CODE = localStorage.getItem("companyCode");
  let API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const COMPANY_NAME = API_PATHS[0]?.COMPNAME || "Company";
  const [groupedModuleSubmoduleMain, setGroupedModuleSubmoduleMain] =
    useState(null);
  const { data: datagetAllMenuOfThisRole, get: getAllMenuOfThisRole } =
    useApi();
  // console.log(
  //   "group module sub module main from header",
  //   groupedModuleSubmoduleMain,
  // );
  // console.log("Menu list from Header component", datagetAllMenuOfThisRole);
  const [current_role_of_logged_in_user, setCurrent_role_of_logged_in_user] =
    useState(null);

  const getModuleId = (menuId) => {
    for (const module of groupedModuleSubmoduleMain || []) {
      for (const sub of module.SUBMODULES || []) {
        if (
          sub.MENUS.some(
            (m) =>
              m.MENUID?.trim().toUpperCase() === menuId.trim().toUpperCase(),
          )
        ) {
          return module.MODULEID;
        }
      }
    }
    return "";
  };

  const getModuleObject = (menuId) => {
    for (const module of groupedModuleSubmoduleMain || []) {
      for (const sub of module.SUBMODULES || []) {
        if (
          sub.MENUS.some(
            (m) =>
              m.MENUID?.trim().toUpperCase() === menuId.trim().toUpperCase(),
          )
        ) {
          return module;
        }
      }
    }
    return null;
  };
  const getMenuName = (menuId) => {
    for (const module of groupedModuleSubmoduleMain || []) {
      for (const sub of module.SUBMODULES || []) {
        const menu = sub.MENUS.find(
          (m) => m.MENUID?.trim().toUpperCase() === menuId.trim().toUpperCase(),
        );
        if (menu) {
          return menu.MENUNAME;
        }
      }
    }
    return menuId.replace(/_/g, " ");
  };

  const getModuleColor = (moduleId) => {
    const colors = {
      FINANCE: "bg-green-600",
      SALES: "bg-blue-600",
      PURCHASE: "bg-orange-600",
      MARKETING: "bg-pink-600",
      MASTER: "bg-purple-600",
      INVENTORY: "bg-teal-600",
      HR: "bg-indigo-600",
      REPORTS: "bg-cyan-600",
      SETTINGS: "bg-amber-600",
    };

    return colors[moduleId] || "bg-gray-600";
  };
  const [tutorOpen, setTutorOpen] = useState(false);
  const location = useLocation();

  // Determine dynamic context based on URL
  const getContext = () => {
    const pathParts = location.pathname.split("/").filter(Boolean);
    return {
      Module: pathParts[0] || "Dashboard",
      Screen: pathParts[pathParts.length - 1] || "Home",
    };
  };
  const handleSearchChange = (e) => {
    setSearchItem(e.target.value);
  };

  const clearSearchItem = () => {
    setSearchItem("");
    setFilteredMenus([]);
  };

  const handleChange = (e) => {
    console.log("team is selected:1", e.target.value);
    setTeam(e.target.value);
  };

  const handleDeptChange = async (e) => {
    const userSelectedDepartment = e.target.value;
    if (!userSelectedDepartment) return;

    setDept(userSelectedDepartment);
    localStorage.setItem("currentSelectedDepartment", userSelectedDepartment);

    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    if (currentUserObject) {
      const selectedDeptObj = currentUserObject.find(
        (dept) => dept.DEPTNO?.trim() === userSelectedDepartment?.trim(),
      );
      if (selectedDeptObj && selectedDeptObj.DEPTLOC) {
        localStorage.setItem("departmentLocation", selectedDeptObj.DEPTLOC);
      }
    }

    try {
      const baseUrl = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";
      const response = await fetch(
        `${baseUrl}/api/CpaysCount/${COMPANY_CODE}/DEPTLH/${userSelectedDepartment}/-`,
      );
      const data = await response.json();

      if (data && data.length > 0) {
        let currentApiPaths = JSON.parse(localStorage.getItem("apiPaths"));
        if (currentApiPaths && currentApiPaths.length > 0) {
          // Update header and footer images from the API response
          currentApiPaths[0].REP_HEADER =
            data[0].rh || currentApiPaths[0].REP_HEADER;
          currentApiPaths[0].REP_FOOTER =
            data[0].rf || currentApiPaths[0].REP_FOOTER;

          localStorage.setItem("apiPaths", JSON.stringify(currentApiPaths));
        }
      }
    } catch (error) {
      console.error("Error updating department header/footer:", error);
    }

    window.location.reload();
  };

  const handleClick = () => {
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroup = currentUserObject[0].accessgrp;

    if (userAccessGroup?.trim().toUpperCase() === "CADMIN") {
      navigate("/");
    } else {
      navigate("/");
    }
  };

  const [userDepartmentList, setUserDepartment] = useState(null);
  const [userName, setUserName] = useState(null);

  // useEffect(() => {
  //   console.log("userDepartmentList in Header", userDepartmentList);
  // }, [userDepartmentList]);

  useEffect(() => {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    // const currentUserName = CURRENT_USER_NAME;
    let currentDepartment = localStorage.getItem("currentSelectedDepartment");

    if (
      !currentDepartment ||
      currentDepartment?.trim() === "" ||
      currentDepartment === "null"
    ) {
      currentDepartment = currentUser?.[0]?.DEPTNO || "";
    }
    localStorage.setItem("currentSelectedDepartment", currentDepartment);

    // console.log(
    //   "currentUser in Header currentDepartment",
    //   currentUser,
    //   currentDepartment,
    // );

    if (currentUser) {
      const selectedDeptObj = currentUser.find(
        (dept) => dept.DEPTNO?.trim() === currentDepartment?.trim(),
      );
      if (selectedDeptObj && selectedDeptObj.DEPTLOC) {
        localStorage.setItem("departmentLocation", selectedDeptObj.DEPTLOC);
      } else if (currentUser[0]?.DEPTLOC) {
        localStorage.setItem("departmentLocation", currentUser[0].DEPTLOC);
      }

      setUserDepartment(currentUser);
      setUserName(currentUser[0]?.user);
      setDept(currentDepartment);
    } else {
      console.log("No currentUser found in localStorage");
      setUserDepartment(null);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (window.innerWidth >= 576) return;

      if (
        !hideRightSideBar && // Sidebar is open
        rightSidebarRef.current &&
        !rightSidebarRef.current.contains(event.target) &&
        toggleButtonRef.current &&
        !toggleButtonRef.current.contains(event.target)
      ) {
        sethideRightSideBar(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hideRightSideBar]);

  useEffect(() => {
    if (searchItem.trim() === "") {
      setFilteredMenus([]);
      setFocusedIndex(-1);
    } else {
      const normalizedSearch = searchItem.toLowerCase().replace(/\s+/g, "_");
      const filtered = menu_list.filter((menu) => {
        const moduleId = getModuleId(menu.menu_id);
        // Only show if the menu is present in the API response (has an assigned module)
        if (!moduleId) return false;

        const menuName = getMenuName(menu.menu_id)
          .toLowerCase()
          .replace(/\s+/g, "_");
        const menuId = menu.menu_id.toLowerCase();
        return (
          menuName.includes(normalizedSearch) ||
          menuId.includes(normalizedSearch)
        );
      });
      setFilteredMenus(filtered);
      setFocusedIndex(-1);
    }
  }, [searchItem, menu_list, groupedModuleSubmoduleMain]);

  useEffect(() => {
    const handleClickOutsideSearch = (event) => {
      if (
        searchDropdownRef.current &&
        !searchDropdownRef.current.contains(event.target)
      ) {
        setFilteredMenus([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutsideSearch);

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideSearch);
    };
  }, []);

  const getRoleOfUser = () => {
    const currentUserObject = JSON.parse(localStorage.getItem("currentUser"));
    const userAccessGroup = currentUserObject[0].accessgrp;
    setCurrent_role_of_logged_in_user(userAccessGroup?.trim().toUpperCase());
  };

  useEffect(() => {
    getRoleOfUser();
  }, []);

  useEffect(() => {
    if (current_role_of_logged_in_user) {
      let apiurl = `https://cubixweberp.com:213/api/ClientRoleMenuControl/${COMPANY_CODE}/${COMPANY_CODE}/${current_role_of_logged_in_user}/MAINMENU/-`;
      getAllMenuOfThisRole(apiurl);
    }
  }, [current_role_of_logged_in_user]);

  useEffect(() => {
    if (datagetAllMenuOfThisRole) {
      const grouped = [];
      datagetAllMenuOfThisRole.forEach((item) => {
        let module = grouped.find((m) => m.MODULEID === item.MODULEID);
        if (!module) {
          module = {
            MODULEID: item.MODULEID,
            MODULENAME: item.MODULENAME,
            SUBMODULES: [],
          };
          grouped.push(module);
        }
        let submodule = module.SUBMODULES.find(
          (sm) => sm.SUBMODULEID === item.SUBMODULEID,
        );
        if (!submodule) {
          submodule = {
            SUBMODULEID: item.SUBMODULEID,
            SUBMODULENAME: item.SUBMODULENAME,
            MENUS: [],
          };
          module.SUBMODULES.push(submodule);
        }
        submodule.MENUS.push({
          MENUID: item.MENUID,
          MENUNAME: item.MENUNAME,
          IMAGEPATH: item.IMAGEPATH,
          ORDER: item.ORDER,
        });
      });
      setGroupedModuleSubmoduleMain(grouped);
    }
  }, [datagetAllMenuOfThisRole]);

  const toggleHideRightSideBar = () => {
    sethideRightSideBar((prev) => !prev);
  };
  const onSignOut = () => {
    const confirmed = window.confirm("Are you sure want to sign out?");
    if (!confirmed) return;
    localStorage.removeItem("currentUser");
    localStorage.removeItem("currentUserName");
    localStorage.removeItem("currentUserEmployeeID");
    localStorage.removeItem("currentSelectedDepartment");
    localStorage.removeItem("currentUserLoginStatus");
    navigate("/");
  };
  const toggleFullScreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.error(
          `Error trying to enable full-screen mode: ${err.message} (${err.name})`,
        );
      });
    } else {
      document.exitFullscreen();
    }
  };

  return (
    <header className="text-black p-1 flex items-center bg-[#f8f8f8] justify-between w-full ">
      <div className="flex gap-6 justify-between items-center header-logo-togglebutton-container">
        <div
          className="flex items-center gap-3 group cursor-pointer"
          onClick={handleClick}
        >
          <div className="relative">
            <img
              src={salesDood2}
              alt="Logo"
              className="w-auto h-12 lg:h-14 transition-transform duration-300 group-hover:scale-105"
            />
          </div>
        </div>

        <div className="lg:hidden flex items-center gap-1 ">
          <button
            ref={toggleButtonRef}
            onClick={toggleHideRightSideBar}
            className="sm:hidden p-1 text-[#808080] hover:text-[#606060] transition-colors duration-200"
          >
            <Settings className="w-6 h-6" />
          </button>

          <button
            title="Logout"
            onClick={onSignOut}
            className="sm:hidden text-white bg-red-500 flex flex-col items-center  transition-colors duration-200 p-1 hover:bg-red-600 rounded-full"
          >
            <Power className="w-5 h-5" />
          </button>
        </div>
      </div>

      {/* Overlay for mobile when sidebar is open */}
      {!hideRightSideBar && (
        <div
          className="sm:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={() => sethideRightSideBar(true)}
        />
      )}

      <div
        ref={rightSidebarRef}
        className={`
          header-right-part flex justify-center items-center gap-2 z-40
          sm:flex sm:flex-row sm:static sm:bg-transparent sm:h-auto sm:p-0 sm:translate-x-0
          ${hideRightSideBar
            ? "max-sm:translate-x-full"
            : "max-sm:translate-x-0"
          }
          max-sm:fixed max-sm:right-0 max-sm:top-0 max-sm:h-screen max-sm:w-80 
          max-sm:bg-white max-sm:shadow-2xl max-sm:flex-col max-sm:justify-start 
          max-sm:items-stretch max-sm:p-6 max-sm:pt-16
          max-sm:transition-transform max-sm:duration-300 max-sm:ease-in-out
        `}
      >
        {/* Close button for mobile */}
        <button
          onClick={toggleHideRightSideBar}
          className="sm:hidden absolute top-4 right-4 p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-full transition-colors duration-200"
        >
          <X className="w-6 h-6" />
        </button>

        <div className="relative max-sm:w-full max-sm:mb-6">
          <input
            type="text"
            value={searchItem}
            onChange={handleSearchChange}
            onKeyDown={(e) => {
              if (filteredMenus?.length > 0) {
                if (e.key === "ArrowDown") {
                  e.preventDefault();
                  setFocusedIndex((prev) =>
                    prev < filteredMenus.length - 1 ? prev + 1 : 0,
                  );
                } else if (e.key === "ArrowUp") {
                  e.preventDefault();
                  setFocusedIndex((prev) =>
                    prev > 0 ? prev - 1 : filteredMenus.length - 1,
                  );
                } else if (e.key === "Enter") {
                  e.preventDefault();
                  if (
                    focusedIndex >= 0 &&
                    focusedIndex < filteredMenus.length
                  ) {
                    const menu = filteredMenus[focusedIndex];
                    const moduleObj = getModuleObject(menu.menu_id);
                    if (moduleObj && setCurrentSelectedMouleObject) {
                      setCurrentSelectedMouleObject(moduleObj);
                    }
                    navigate(menu.url_path);
                    setSearchItem("");
                    setFilteredMenus([]);
                    setFocusedIndex(-1);
                  }
                } else if (e.key === "Escape") {
                  setFilteredMenus([]);
                  setFocusedIndex(-1);
                }
              }
            }}
            placeholder="Search menu..."
            className="w-full py-2 pl-10 pr-4 rounded-lg bg-white text-black placeholder-gray-400 border border-gray-200 shadow-sm max-sm:border-gray-300"
          />
          <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
            <AiOutlineSearch className="text-gray-500" />
          </div>
          {searchItem && (
            <div
              className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer hover:text-gray-700 transition-colors duration-200"
              onClick={clearSearchItem}
            >
              <AiOutlineClose className="text-gray-500" />
            </div>
          )}

          {filteredMenus?.length > 0 && (
            <div
              ref={searchDropdownRef}
              className="absolute top-full left-0 right-0 bg-white border border-gray-200 rounded-lg shadow-lg z-50 max-h-60 overflow-y-auto mt-1"
            >
              {filteredMenus?.map((menu, index) => (
                <div
                  key={menu.menu_id}
                  onClick={() => {
                    const moduleObj = getModuleObject(menu.menu_id);
                    if (moduleObj && setCurrentSelectedMouleObject) {
                      setCurrentSelectedMouleObject(moduleObj);
                    }
                    navigate(menu.url_path);
                    setSearchItem("");
                    setFilteredMenus([]);
                  }}
                  className="flex items-center justify-between px-4 py-3 hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                >
                  <span className="text-sm text-gray-700">
                    {getMenuName(menu.menu_id)}
                  </span>
                  <span
                    className={`text-xs text-white uppercase ${getModuleColor(
                      getModuleId(menu.menu_id),
                    )} px-2 py-0.5 rounded-full font-semibold truncate`}
                  >
                    {getModuleId(menu.menu_id)}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* <div className="max-sm:w-full max-sm:mb-4">
          <FormControl
            sx={{
              minWidth: { xs: "100%", sm: 110 },
              "& .MuiInputBase-root": {
                fontSize: "14px",
              },
            }}
            size="small"
          >
            <InputLabel
              id="team-select-label"
              sx={{
                fontFamily: "'Figtree', sans-serif",
                fontSize: "14px",
              }}
            >
              Team
            </InputLabel>
            <Select
              labelId="team-select-label"
              id="team-select"
              value={team}
              label="Team"
              onChange={handleChange}
              MenuProps={{
                PaperProps: {
                  sx: {
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                  },
                },
              }}
            >
              <MenuItem value="">
                <em className="text-gray-400">Select Team</em>
              </MenuItem>
              <MenuItem value="general">General</MenuItem>
              <MenuItem value="teamA">Team A</MenuItem>
              <MenuItem value="teamB">Team B</MenuItem>
              <MenuItem value="teamC">Team C</MenuItem>
              <MenuItem value="teamD">Team D</MenuItem>
            </Select>
          </FormControl>
        </div> */}

        {/* Department Select */}
        <div className="max-sm:w-full max-sm:mb-6">
          <FormControl
            sx={{
              minWidth: { xs: "100%", sm: 110 },
              "& .MuiInputBase-root": {
                fontSize: "14px",
              },
            }}
            size="small"
          >
            <InputLabel
              id="department-select-label"
              sx={{
                fontFamily: "'Figtree', sans-serif",
                fontSize: "14px",
              }}
            >
              Department
            </InputLabel>
            <Select
              labelId="department-select-label"
              id="department-select"
              value={dept}
              label="Department"
              onChange={handleDeptChange}
              MenuProps={{
                PaperProps: {
                  sx: {
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px",
                  },
                },
              }}
            >
              <MenuItem value="">
                <em className="text-gray-400">Select Department</em>
              </MenuItem>
              {userDepartmentList?.map((itemDept) => (
                <MenuItem key={itemDept.DEPTNO} value={itemDept.DEPTNO?.trim()}>
                  {itemDept.DEPTNO?.trim()}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        <div className="flex items-center justify-center gap-4 max-sm:flex-col max-sm:items-stretch max-sm:gap-6 max-sm:mt-4">
          {/* Action Buttons Group */}
          <div className="flex items-center justify-center gap-2 max-sm:justify-around max-sm:py-4 max-sm:border-t max-sm:border-b max-sm:border-gray-200">
            {API_PATHS &&
              API_PATHS[0]?.AI_FEATURE === "true" &&
              localStorage.getItem("currentUser") &&
              canUserSeeThis("ZD") && (
                <button
                  onClick={() => setTutorOpen(true)}
                  className="flex items-center gap-2 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full transition-all shadow-lg shadow-indigo-500/20 mr-2"
                >
                  <MessageSquare size={16} />
                  <span className="font-semibold text-xs lg:text-sm">
                    AI Tutor
                  </span>
                </button>
              )}

            {/* Notification Bell */}
            <button className="text-gray-600 relative hover:text-indigo-600 transition-colors duration-200 p-2 hover:bg-indigo-50 rounded-full">
              <AiOutlineBell className="text-xl" />
              <span className="absolute top-1 right-1 bg-green-600 text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center border-2 border-[#f8f8f8]">
                7
              </span>
            </button>

            {/* Fullscreen Toggle */}
            <button
              onClick={toggleFullScreen}
              title="Toggle Full screen"
              className="text-gray-600 hover:text-indigo-600 transition-colors duration-200 p-2 hover:bg-indigo-50 rounded-full"
            >
              <RiFullscreenLine className="text-xl" />
            </button>

            {/* Settings Button */}
            <button
              onClick={() => navigate("/settings")}
              title="Settings"
              className="text-gray-600 hover:text-indigo-600 transition-colors duration-200 p-2 hover:bg-indigo-50 rounded-full"
            >
              <AiOutlineSetting className="text-xl" />
            </button>
          </div>

          {/* User Profile Section with Integrated Dropdown */}
          <div
            className="relative border-l border-gray-300 pl-4  max-sm:border-t max-sm:pt-4 max-sm:border-l-0 max-sm:pl-0"
            ref={profileMenuRef}
          >
            <div
              className="flex items-center gap-3 cursor-pointer p-1 rounded transition-colors duration-200 hover:bg-gray-50 group"
              onClick={() => setProfileMenuOpen(!profileMenuOpen)}
            >
              <div className="flex flex-col items-end hidden lg:flex transition-opacity group-hover:opacity-80">
                <p className="text-sm font-bold text-gray-800 leading-none capitalize">
                  {userName}
                </p>
                <p className="text-[10px] font-medium text-indigo-500 mt-1 uppercase tracking-tighter bg-indigo-100 px-1.5 py-0.5 rounded">
                  {COMPANY_NAME}
                </p>
              </div>

              <div className="relative transition-transform group-hover:scale-105">
                <img
                  src="https://static.vecteezy.com/system/resources/previews/024/766/958/non_2x/default-male-avatar-profile-icon-social-media-user-free-vector.jpg"
                  alt="User Avatar"
                  className="w-10 h-10 rounded-full object-cover border-2 border-white shadow-md"
                />
                {/* Dropdown Indicator */}
                <div className="absolute -bottom-1 -right-1 bg-white rounded-full shadow-sm border border-gray-100 p-0.5">
                  <ChevronDown
                    size={10}
                    className={`text-gray-600 transition-transform duration-300 ${profileMenuOpen ? "rotate-180" : ""}`}
                  />
                </div>
              </div>
            </div>

            {/* Dropdown Menu Portal */}
            {profileMenuOpen && (
              <>
                {/* Invisible backdrop to catch outside clicks */}
                <div
                  className="fixed inset-0 z-50 cursor-default"
                  onClick={() => setProfileMenuOpen(false)}
                ></div>

                <div className="absolute right-0 mt-3 w-52 bg-white rounded-xl shadow-2xl border border-gray-100 z-50 py-2 overflow-hidden animate-in fade-in zoom-in slide-in-from-top-2 duration-200">
                  {/* Mobile User Info (Hidden on Desktop) */}
                  <div className="px-4 py-3 border-b border-gray-50 lg:hidden bg-gray-50/50">
                    <p className="text-sm font-bold text-gray-800">
                      {userName}
                    </p>
                    <p className="text-[10px] text-indigo-500 font-bold uppercase">
                      {COMPANY_NAME}
                    </p>
                  </div>

                  <button
                    // onClick={() => {
                    //   setProfileMenuOpen(false);
                    //   navigate("/profile");
                    // }}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
                  >
                    <AiOutlineUser size={18} />
                    My Profile
                  </button>

                  <button
                    onClick={() => {
                      setProfileMenuOpen(false);
                      navigate("/settings");
                    }}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
                  >
                    <AiOutlineSetting size={18} />
                    Account Settings
                  </button>

                  <div className="my-1 border-t border-gray-100"></div>

                  <button
                    onClick={() => {
                      setProfileMenuOpen(false);
                      onSignOut();
                    }}
                    className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-red-50 transition-colors font-semibold"
                  >
                    <LogOut size={18} />
                    Sign Out
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* {tutorOpen && <AiTutorModal onClose={() => setTutorOpen(false)} />} */}
      {/* <Modal
        onClose={() => setTutorOpen(false)}
        isOpen={tutorOpen}
        header={false}
        size="xxl"
      >
        <AiTutorModal onClose={() => setTutorOpen(false)} />
      </Modal> */}
    </header>
  );
};

export default Header;
